import React from "react";

/**
 * Reusable summary card with label on the left and value on the right.
 *
 * @param {{ label: string, value: string|number, className?: string }} props
 *
 * @example
 * <SummaryCard label="Total opportunity" value={456} />
 */
const SummaryCard = ({ label, value, className = "" }) => {
  return (
    <div
      className={`flex items-center justify-between p-4 border border-solid border-primary-border bg-primary-bg rounded-xl ${className}`}
    >
      <span className="text-base font-normal text-default">{label}</span>
      <span className="text-xl font-semibold text-primary">{value}</span>
    </div>
  );
};

export default SummaryCard;
